import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducers from "./reducers/index";

const store = createStore(reducers, applyMiddleware(thunk));

// store.subscribe(() => console.log("State after dispatch: ", store.getState()));

export default store;
